import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

import { getAuthToken } from '@/helpers/Authentication/authClient';
import { FavouritesList, FavouritesListItem } from '@/helpers/Favourites/types';

export const createFavouritesList = async (listingId: string): Promise<FavouritesList | null> => {
  try {
    const authToken = await getAuthToken();

    if (!authToken) {
      return null;
    }

    const { data } = await axios.post(
      import.meta.env.VUE_FAVOURITES_API_ENDPOINT,
      {
        listingId: listingId,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return data;
  } catch (error) {
    if (error.response?.status !== 401) {
      datadogRum.addError(error);
    }
    return null;
  }
};

export const getFavouritesList = async (): Promise<FavouritesList[] | null> => {
  try {
    const authToken = await getAuthToken();

    if (!authToken) {
      return null;
    }

    const { data } = await axios.get(import.meta.env.VUE_FAVOURITES_API_ENDPOINT, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return data;
  } catch (error) {
    if (error.response?.status !== 401) {
      datadogRum.addError(error);
    }
    return null;
  }
};

export const updateFavouritesList = async (
  favouritesListId: string | null | undefined,
  listingId: string | null | undefined,
  text?: string,
): Promise<FavouritesListItem | null> => {
  try {
    const authToken = await getAuthToken();

    if (!authToken) {
      return null;
    }

    const { data } = await axios.put(
      `${import.meta.env.VUE_FAVOURITES_API_ENDPOINT}/list/${favouritesListId}`,
      {
        listItem: {
          itemId: listingId,
          text: text || '',
        },
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return data;
  } catch (error) {
    if (error.response?.status !== 401) {
      datadogRum.addError(error);
    }
    return null;
  }
};

export const removeFavouritesListItem = async (
  favouritesListId: string | null | undefined,
  listingId: string | null | undefined,
): Promise<void> => {
  try {
    const authToken = await getAuthToken();

    if (!authToken) {
      return;
    }

    const { data } = await axios.put(
      `${import.meta.env.VUE_FAVOURITES_API_ENDPOINT}/list/${favouritesListId}/listings/${listingId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return data;
  } catch (error) {
    if (error.response?.status !== 401) {
      datadogRum.addError(error);
    }
  }
};
